<template>
  <div class="p-fluid p-formgrid p-grid">           

    <div class="p-field p-col-12 p-md-12">
      <h6 class="p-text-bold">Abrangência <span class="campo-obrigatorio">*</span></h6>
      <div class="p-fluid p-formgrid p-grid">        
        <div class="p-field p-col-2 p-md-2">
          <label>Atrasos</label>
          <InputText type="number" v-model.number="politicaAtrasos.atrasoMaximoDiaMinuto" placeholder="Máx. dia (minutos)" class="p-text-center" min="0"/>
        </div>
      </div>
      <div class="p-fluid p-formgrid p-grid">    
        <div class="p-field p-col-2 p-md-2">
          <label>Saídas antecipadas</label>
          <InputText type="number" v-model.number="politicaAtrasos.saidaAntecipadaMaximoDiaMinuto" placeholder="Máx. dia (minutos)" class="p-text-center" min="0"/>
        </div>
      </div> 
      <div class="p-fluid p-formgrid p-grid">        
        <div class="p-field p-col-2 p-md-2">
          <label>Excessos no intervalo de refeição</label>
          <InputText type="number" v-model.number="politicaAtrasos.excessoIRMaximoDiaMinuto" placeholder="Máx. dia (minutos)" class="p-text-center" min="0"/>
        </div>       
      </div>      
    </div>     

  </div>
</template>

<script>
import PoliticaAtrasos from '@/model/PoliticaAtrasos';

export default {
  data() {
    return {
      politicaAtrasos: new PoliticaAtrasos(),
    }
  },
  methods: {
    setConfiguracao(politicaAtrasos) {
      this.politicaAtrasos = politicaAtrasos;
    },
    getConfiguracao() {      
      if(this.politicaAtrasos.atrasoMaximoDiaMinuto === '' || this.politicaAtrasos.saidaAntecipadaMaximoDiaMinuto === ''
        || this.politicaAtrasos.excessoIRMaximoDiaMinuto === '') {
          throw 'Atrasos: Informe os campos obrigatórios'
      }
      return this.politicaAtrasos;
    }
  },
  created() {
    this.politicaAtrasos.atrasoMaximoDiaMinuto = 5;       
    this.politicaAtrasos.saidaAntecipadaMaximoDiaMinuto = 5;       
    this.politicaAtrasos.excessoIRMaximoDiaMinuto = 5
  }
}
</script>

<style>

</style>